import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoint } from '../components/PainPoint';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
export function Home() {
  return <>
      <Hero data-id="element-1211" data-mp="2x7slkucsfju5" />
      <PainPoint data-id="element-1212" data-mp="1zhxkqdjnmqzd" />
      <Services data-id="element-1213" data-mp="1zih29t5e7dcv" />
      <WhyChooseUs data-id="element-1214" data-mp="1ziz8nilrr7yi" />
      <Testimonials data-id="element-1215" data-mp="1zjig25dsmdya" />
      <CTASection data-id="element-1216" data-mp="1zk20bsqx1efh" />
    </>;
}